export enum NoticeType {
    AppraisalNotice = 0,
    AppraisalReport = 1,
    IncompleteFile = 2,
    AdverseAction = 3,
    FloodNotice = 4,
    PostClosingCertNotice = 5,
}
